import React, { Component } from "react";
import ProductLandingPage from "../../product-landing";

class Login extends Component {
  render() {
    return <ProductLandingPage variant="login" />;
  }
}

export default Login;
